import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';
import PropTypes from 'prop-types';
import Loading from './Loading';

class LoadingButton extends React.Component {

  render() {

    const { classes, endIcon, startIcon, disabled } = this.props;

    return (
      <Tooltip title="Processing">
        <span>
          <Button
            variant="contained"
            color="secondary"
            style={{width: 122, height: 40}}
            disabled={disabled}
            endIcon={endIcon}
            startIcon={startIcon}
            className={classes.button}>
            <span style={{ display: 'inline-block', paddingTop: '4px' }}>
              <Loading />
            </span>
          </Button>
        </span>
      </Tooltip>
    );
  }
}

LoadingButton.defaultProps = {
  disabled: false
};

LoadingButton.propTypes = {
  disabled: PropTypes.bool,
  title: PropTypes.string,
  endIcon: PropTypes.object,
  startIcon: PropTypes.object,
  classes: PropTypes.object
};

export default withStyles(styles)(LoadingButton);